import { CaseSetupDto, Deserializable } from '../../lib';
import { ProductPickerDto } from './product-picker-dto.model';

export class KfiRegistrationDto implements Deserializable {
  public KfiCreationDto: CaseSetupDto;
  public ProductPickerDto: ProductPickerDto;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.KfiCreationDto = new CaseSetupDto().deserialize(input.KfiCreationDto);
    this.ProductPickerDto = new ProductPickerDto().deserialize(input.ProductPickerDto);

    return this;
  }
}
